
import Vue from 'vue'
import SimpleBarrel from "@/components/SimpleBarrel.vue";
import { BarrelSummary } from "@/services/ApiService";
export default Vue.extend({
  name: 'BarrelCarousel',
  components: {SimpleBarrel},
  data:() => ({
    initialBarrels:[] as BarrelSummary[],
    barrels: [] as BarrelSummary[],
    search: ''
  }),
  props: {
    customerName: String,
    customerPhoneNumber: String,
    pBarrels: {
      type: Array,
      required: true
    }
  },
  computed: {
    noBarrelMatchTitle():string{
      return `No match for '${this.search}'`
    },
    showNavs(): boolean{
      return this.barrels?.length > 1;
    }
  },
  methods: {
    getPybNumber(input: string): string{
      return input?.split("_")[0];
    },
    searchForBarrel(input: string){
      this.search = input;
      if(!input){
        this.barrels = this.initialBarrels;
        return;
      }

      let matchedBarrel: BarrelSummary[] = []
      this.initialBarrels.forEach(barrel => {
        if(barrel.BarrelNum.includes(input) || barrel.BarrelName.toLowerCase().includes(input.toLowerCase()))
          matchedBarrel.push(barrel)
      });

      this.barrels = matchedBarrel;
    }
  },
  mounted(){
    this.barrels = this.pBarrels as BarrelSummary[];
    this.initialBarrels = this.barrels;
  }
})
